let reportReviewTable = [{
        label: "序号",
        prop: "reportID",
        sortable: 1
    },
    {
        label: "小结类型",
        prop: "reportType"
    },
    {
        label: "姓名",
        prop: "userName"
    },

    {
        label: "所属科/处室",
        prop: "department"
    },
    {
        label: "年度",
        prop: "year"
    },
    {
        label: "季度",
        prop: "season"
    },
    {
        label: "提交时间",
        prop: "submitDate"
    },
    {
        label: "报告内容",
        prop: "detail"
    },
    {
        label: "审批状态",
        prop: "state"
    },
]

export {
    reportReviewTable
}